// composables/aceites/useAceites.js - Funciones utilitarias y API calls
export const useAceites = () => {
  const config = useRuntimeConfig();
  const baseUrlUtilitario = config.public.nuxtUrlUtilitarioAceites;

  const debug = {
    enabled: config.public.modo === 'DEV',
    log(...args) {
      if (this.enabled) console.log("[composables->aceites->useAceites.js]", ...args);
    },
    error(...args) {
      if (this.enabled) console.error(...args);
    },
  };

  // VALIDACIONES DE FORMULARIO
  const validateEmail = (email) => {
    const emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    return email && emailRegex.test(email);
  };

  const validatePhoneNumber = (phone, country) => {
    const phoneRegex = /^[0-9]+$/;
    return (
      phone &&
      (country === '+56'
        ? phone.length === 9
        : phone.length >= 10 && phone.length <= 12) &&
      phoneRegex.test(phone)
    );
  };

  const validateString = (value) => {
    const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ\s]+$/;
    if (!regex.test(value)) {
      return value.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ\s]+/g, "");
    }
    return value;
  };

  // FUNCIONES UTILITARIAS DE FORMATO
  const formatearPrecio = (precio) => {
    if (typeof precio === "string") {
      precio = parseFloat(precio);
    }
    return new Intl.NumberFormat("es-CL").format(precio);
  };

  const formatearFecha = (fecha, hora) => {
    if (!fecha || !hora) return '';
    
    const fechaObj = new Date(fecha + 'T00:00:00');
    
    const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 
                  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    
    const diaSemana = dias[fechaObj.getDay()];
    const dia = fechaObj.getDate();
    const mes = meses[fechaObj.getMonth()];
    const año = fechaObj.getFullYear();
    
    return `${diaSemana}, ${dia} de ${mes} de ${año}. Hora ${hora}`;
  };

  const formatearModalidad = (modo) => {
    if (modo === 1) return 'Espera Vehículo';
    if (modo === 2) return 'Deja Vehículo';
    if (modo === 3) return 'Retira Vehículo';
    return 'Modo no válido';
  };

  const formatearCodigoFiltro = (codigo_filtro, descripcion_filtro) => {
    //debug.log("codigo_filtro: ", codigo_filtro);
    //debug.log("descripcion_filtro: ", descripcion_filtro);
    if (codigo_filtro === 'Informacion en Local') {
      return 'No incluye filtro, Llamaremos para entregar el valor vía telefónica';
    }
    if (descripcion_filtro) {
      return descripcion_filtro;
    }
    return '';
  };

  const transformarModalidad = (valor_modo) => {
    if(valor_modo == 2) return 'DEJA';
    if(valor_modo == 3) return 'RETIRA';
    return 'ESPERA';
  }

  // VALIDACIONES DE DATOS
  const validarDatosVehiculo = (datos) => {
    /**
     * ================================
     * VALIDACIÓN HISTÓRICA (DESACTIVADA)
     * ================================
     * Antes exigíamos: marca, ano, modelo, version y local.
     * Hoy el flujo actual no debe bloquear por "version".
     */
    /*
    const { marca, ano, modelo, version, local } = datos;
    return marca && ano && modelo && version && local;
    */

    //  Flujo actual (sin versión)
    const { marca, ano, modelo, local } = datos || {};
    return !!(marca && ano && modelo && local);
  };

  const validarDatosPatente = (datos) => {
    const { patente, local } = datos;
    return patente && patente.length === 6 && local;
  };

  const validarBusqueda = (searchData) => {
    debug.log("searchData: ", searchData);
    const { local, modo_busqueda, patente, marca, ano, modelo } = searchData;

    if (!local) return false;

    if (modo_busqueda === "por_patente") {
      return patente && patente.length === 6;
    }

    if (modo_busqueda === "por_auto") {
      return !!(marca && ano && modelo);
    }

    return false;
  };

  const validarProductos = (producto_seleccionado) => {
    /**
     * ================================
     * VALIDACIÓN HISTÓRICA (DESACTIVADA)
     * ================================
     * Antes se validaba producto_seleccionado y sus campos:
     *  - codigo_filtro
     *  - cadena_codigos
     *  - cadena_cantidad_envases
     *
     * Hoy el flujo actual NO depende de estos datos para avanzar.
     */
    /*
    if (!producto_seleccionado || !producto_seleccionado.codigo_filtro) {
      debug.log('No hay codigo_filtro disponible');
      return false;
    }

    if (!producto_seleccionado || !producto_seleccionado.cadena_codigos) {
      debug.log('No hay cadena_codigos disponible');
      return false;
    }

    if (!producto_seleccionado || !producto_seleccionado.cadena_cantidad_envases) {
      debug.log('No hay cadena_cantidad_envases disponible');
      return false;
    }

    return true;
    */

    //  Flujo actual: no bloquear por producto_seleccionado
    return true;
  };


  const validarEspecificaciones = (info_especificaciones) => {
    /**
     * ================================
     * VALIDACIÓN HISTÓRICA (DESACTIVADA)
     * ================================
     * Antes se exigía: info_especificaciones.id_vehiculo
     * Hoy el flujo actual NO debe bloquear por esto.
     */
    /*
    if (!info_especificaciones || !info_especificaciones.id_vehiculo) {
      debug.log('No hay id_vehiculo seleccionado');
      return false;
    }
    return true;
    */

    //  Flujo actual: no bloquear por info_especificaciones
    return true;
  };


  const validarDatosPersonales = (form = {}, opciones = {}) => {
    const { requerir_apellido_materno = true } = opciones;

    const email = String(form.email ?? '').trim();
    const nombre = String(form.nombre ?? '').trim();
    const apellido_paterno = String(form.apellido_paterno ?? '').trim();
    const apellido_materno = String(form.apellido_materno ?? '').trim();

    // limpia espacios; NO altera el resto de la lógica del validador existente
    const telefono = String(form.telefono ?? '').replace(/\s+/g, '').trim();
    const pais = String(form.pais ?? '').trim();

    if (!email || !validateEmail(email)) return false;
    if (!nombre) return false;
    if (!apellido_paterno) return false;

    // ahora es condicional
    if (requerir_apellido_materno && !apellido_materno) return false;

    if (!validatePhoneNumber(telefono, pais)) return false;

    return true;
  };


  // URLs DE RECURSOS
  const getImagenProducto = (codigo) => {
    return `${baseUrlUtilitario}/fotos/${codigo}.png`;
  };

  const getImagenMarca = (marca) => {
    return `${baseUrlUtilitario}/marcas/${marca}.png`;
  };

  const getFichaTecnica = (codigo) => {
    return `${baseUrlUtilitario}/fichas/${codigo}.jpg`;
  };

  const getAudioProducto = (codigo) => {
    return `${baseUrlUtilitario}/audios/${codigo}.mp3`;
  };

  const cargarLubricantes = async () => {
    const response = await $fetch("/api/aceites/lubricantes", {
      method: "POST",
    });

    if (response.status === "success" && response.data?.Lista) {
      return response.data.Lista;
    }

    throw new Error(response.message || "Error al cargar lubricantes SAE");
  };

  // API CALLS
  const cargarCalendario = async (data) => {
    const response = await $fetch("/api/aceites/calendario", {
      method: "POST",
      query: { action: "calendario" },
      body: data,
    });

    if (response.status === "success") {
      return response.data;
    } else {
      throw new Error(response.message || "Error desconocido al cargar calendario");
    }
  };

  const cargarProductos = async (vehiculoData) => {
    const response = await $fetch("/api/aceites/productos", {
      method: "POST",
      query: { action: "productos" },
      body: vehiculoData,
    });

    if (response.status === "success") {
      return response.data;
    } else {
      throw new Error(response.message || "Error desconocido al cargar productos");
    }
  };

  const cargarDetalleAgendamiento = async (data) => {
    const response = await $fetch("/api/aceites/detalle", {
      method: "POST",
      query: { action: "getDetalleAgendamiento" },
      body: data,
    });

    if (response.status === "success") {
      return response.data;
    } else {
      throw new Error(response.message || "Error desconocido al cargar detalle de agendamiento");
    }
  };

  const buscarMarcas = async () => {
    const response = await $fetch("/api/aceites/vehiculos", {
      query: { action: "marcas" },
    });

    if (response.status === "success" && response.data?.Lista) {
      return response.data.Lista;
    } else {
      throw new Error("Error al cargar marcas");
    }
  };

  const buscarAnosPorMarca = async (marca) => {
    const response = await $fetch("/api/aceites/vehiculos", {
      query: {
        action: "anos",
        marca: marca,
      },
    });

    if (response.status === "success" && response.data?.Lista) {
      return response.data.Lista;
    } else {
      throw new Error("Error al cargar años");
    }
  };

  const buscarModelosPorMarcaAno = async (marca, ano) => {
    const response = await $fetch("/api/aceites/vehiculos", {
      query: {
        action: "modelos",
        ano: ano,
        marca: marca,
      },
    });

    if (response.status === "success" && response.data?.Lista) {
      return response.data.Lista;
    } else {
      throw new Error("Error al cargar modelos");
    }
  };

  const buscarVersionesPorMarcaAnoModelo = async (marca, ano, modelo) => {
    const response = await $fetch("/api/aceites/vehiculos", {
      query: {
        action: "versiones",
        modelo: modelo,
        ano: ano,
        marca: marca,
      },
    });

    if (response.status === "success" && response.data?.Lista) {
      return response.data.Lista;
    } else {
      throw new Error("Error al cargar versiones");
    }
  };

  const buscarPorPatente = async (patente, local) => {
    const response = await $fetch("/api/aceites/vehiculos", {
      query: {
        action: "patente",
        patente: patente,
        local: local,
      },
    });

    if (response.status === "success") {
      return response.data;
    } else {
      throw new Error(response.message || "Error al buscar por patente");
    }
  };

  const agendar = async (payload) => {
    try {      
      const response = await $fetch('/api/aceites/agendar', {
        method: 'POST',
        body: {
          action: 'agendar',    //  Acción
          payload: payload      //  Datos anidados
        }
      });
      
      debug.log('=== RESPUESTA DEL BACKEND ===');
      debug.log(response);
      
      if (response.status === 'success') {
        debug.log('Agendamiento exitoso');
        return true;
      } else {
        throw new Error(response.message || 'Error al agendar');
      }
    } catch (error) {
      debug.error('❌ Error agendando:', error);
      return false;
    }
  };

  // RETORNO
  return {
    // Validaciones de formulario
    validateEmail,
    validateString,
    validarDatosPersonales,

    // Formateo
    formatearPrecio,
    formatearFecha,
    formatearModalidad,
    formatearCodigoFiltro,
    transformarModalidad,

    // Validaciones de datos
    validarDatosVehiculo,
    validarDatosPatente,
    validarBusqueda,
    validarProductos,
    validarEspecificaciones,

    // URLs de recursos
    getImagenProducto,
    getImagenMarca,
    getFichaTecnica,
    getAudioProducto,

    // API calls
    cargarLubricantes,
    cargarDetalleAgendamiento,
    cargarProductos,
    cargarCalendario,
    buscarMarcas,
    buscarAnosPorMarca,
    buscarModelosPorMarcaAno,
    buscarVersionesPorMarcaAnoModelo,
    buscarPorPatente,
    agendar,
  };
};